import { useSelector } from "react-redux";
import AuthRoutes from "./authRoutes";
import SuperAdminRoutes from "./superAdminRoutes";
import AdminRoutes from "./adminRoutes";
import TeacherRoutes from "./teacherRoutes";
import { SUPER_ADMIN, ADMIN, TEACHER } from "../constants";
import Preloader from "../components/UI/Preloader";
import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';

const NavRoutes = () => {
  const navigate  = useNavigate();
  const {
    auth: { isLoggedIn, userData, userType, logoutUserSuccess },
  } = useSelector((state) => state);

  const userRoutes = (userData) => {
    if (!userData) return null;

    switch (userType) {
      case SUPER_ADMIN:
        return <SuperAdminRoutes />;
      case ADMIN:
        return <AdminRoutes />;
      case TEACHER:
        return <TeacherRoutes />;
      default:
        return (
          <div className="text-center">
            <h1>You are not authorized to access this panel</h1>
          </div>
        );
    }
  };

  useEffect(()=>{
    !userData && (logoutUserSuccess || !isLoggedIn) && navigate("/sign-in") },[logoutUserSuccess,userData,isLoggedIn])

  return !!localStorage.getItem("jwt") ? (
    isLoggedIn ? (
      userRoutes(userData)
    ) : (
      <Preloader />
    )
  ) : (
    <AuthRoutes />
  );
};

export default NavRoutes;
